import script from "./DerivativeInstruments.vue?vue&type=script&setup=true&lang=js"
export * from "./DerivativeInstruments.vue?vue&type=script&setup=true&lang=js"

import "./DerivativeInstruments.vue?vue&type=style&index=0&id=f11af420&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f11af420"]])

export default __exports__